var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 92.0002C71.397 92.0002 91.9853 71.4052 91.9853 46.0001C91.9853 20.5949 71.397 0 46.0001 0C20.6032 0 0.0149231 20.5949 0.0149231 46.0001C0.0149231 71.4052 20.6032 92.0002 46.0001 92.0002Z",
    fill: "#00DF76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 0C45.9792 0 45.9586 0.000718662 45.9377 0.000718662V91.9993C45.9586 91.9993 45.9792 92 46.0001 92C71.397 92 91.9853 71.4051 91.9853 45.9999C91.9853 20.5947 71.397 0 46.0001 0Z",
    fill: "#01C96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0014 46.9138L38.6011 65.5135C39.4123 66.3246 40.7276 66.3246 41.5388 65.5135L72.0742 34.9781C72.8854 34.1669 72.8854 32.8516 72.0742 32.0404L66.5163 26.4824C65.7051 25.6712 64.3898 25.6712 63.5786 26.4824L41.3689 48.6918C40.5577 49.5029 39.2424 49.5029 38.4312 48.6918L28.4782 38.7388C27.683 37.9436 26.3993 37.9257 25.5822 38.6982L20.0431 43.9353C19.193 44.7393 19.1741 46.0864 20.0014 46.9138Z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5163 26.4824C65.7051 25.6712 64.3897 25.6712 63.5786 26.4824L45.9377 44.1232V61.1147L72.0742 34.9783C72.8854 34.1671 72.8854 32.8517 72.0742 32.0404L66.5163 26.4824Z",
    fill: "#DFEBF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.c8902d34680e1f0476ddae2e78696b3a.svg";